/** Cookie Clicker–style section divider + title for prefs listings. */
export const drawCategoryHeaders = (parent, title, isFirst) => {
    if (!isFirst) {
        const lineWrap = document.createElement("div");
        lineWrap.className = "qt_settingsCategoryLine";
        const line = document.createElement("div");
        line.className = "line";
        lineWrap.appendChild(line);
        parent.appendChild(lineWrap);
    }
    const header = document.createElement("div");
    header.className = "qt_settingsCategoryTitle";
    header.innerHTML = `<b>${title}</b>`;
    parent.appendChild(header);
};
